export const communityFormFeild = [
	{
		type: 'hidden',
		formControlName: 'id',
	},
	{
		type: 'text',
		title: 'Email',
		placeholder: 'Enter User Email',
		formControlName: 'email',
		required: true,

		errorsMsg: [{ type: 'required', message: 'User Id is required' }],
	},
	{
		type: 'text',
		title: 'Name',
		placeholder: 'Enter community name',
		formControlName: 'name',
		required: true,

		errorsMsg: [{ type: 'required', message: 'community name is required' }],
	},
	{
		type: 'select',
		title: 'Community Type',
		placeholder: 'Enter community type',
		formControlName: 'communityType',
		required: true,

		errorsMsg: [{ type: 'required', message: 'community type is required' }],
	},
	{
		type: 'text-editor',
		title: 'About',
		placeholder: 'About community',
		formControlName: 'about',
		required: true,

		errorsMsg: [{ type: 'required', message: 'About is required' }],
	},
	{
		type: 'text-editor',
		title: 'Tagline',
		placeholder: 'Enter tagline',
		formControlName: 'tagline',
		required: true,

		errorsMsg: [{ type: 'required', message: 'Tagline is required' }],
	},
	{
		type: 'text-editor',
		title: 'Community Norms',
		placeholder: 'Enter community norms',
		formControlName: 'communityNorms',
		required: true,

		errorsMsg: [{ type: 'required', message: 'Community norm is required' }],
	},
	{
		type: 'image',
		title: 'Upload Image',
		placeholder: 'Upload JPEG img',
		formControlName: 'imgUpload',
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'Photo url is required' },
			{ type: 'pattern', message: 'Please enter a valid URL' },
		],
	},
];
